import React, {Component} from "react";
import * as actions from '../../../store/actions';
import BreadCrumbs from "../../../Components/UI/BreadCrumbs";
import {
  setConfigRatesStepsAction,
  setExistingConfigRatesStepsAction,
  setRateSheetAndConfigVariablesAction,
  setWindowFieldsDataAction,
  setConfigRatesStepsActionCopy
} from '../../../store/actions/RatesConfigActions';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import Wrp from "../../../hoc/Wrp/Wrp";
import * as ShipConstants from '../../../Global/Constants';
import http from '../../../services/http';

import CreateNew from './CreateNew';
// import Icons from '../../../Components/Icons/Icons';
import {isSet} from '../../../Utils/CommonFunctions';
import { getWindowObjectUsingWindowName } from '../../../Utils/UserFunctions';
// import CloneData from './CloneData';
import $ from 'jquery';
// import ArrayElement from './ArrayElement';
import {findFiltersByFieldIdWithFieldArr,findFiltersOjectByFilterIdAndFilterArray} from '../../../Utils/CommonFunctions';
import GuideModal from './GuideModal';
const LeftContent = React.lazy(() => import('./LeftContent'));
const RightContent = React.lazy(() => import('./RightContent'));

// import LeftContent from './LeftContent';
// import RightContent from './RightContent';
const defualtCalculateLoad =    {
  type : 0,
  name : 'Step ',
  rate_sheet_id : '',
  expression : null,
  expressionVal : null,
  input_fields : [],
  output_fields : [],
  fields : '',
  opt : '',
  outFields : '',
  existOutputVariables : [],
  rate_variable_id : '',
  is_custom_expression : false,
  is_tax : false,
  is_additional_service : false,
  is_loop : false,
  is_assignment : false,
  is_fetch : false,
  is_show:false,
  additional_service_id : '',
  windowFields: [],
  windId : '',
  rate_step_additional_service: {
      "id":null,
      "code": "",
      "cost": 0,
      "charge": 0,
      "percentage": 0,
      "is_active": false,
      "is_package_level": false,
      "is_shipment_level": false,
      "is_per_hundred": false
  },
  rules : [],
  is_source_code: false,
  class_name:'',
  method_name:'execute',
  source_code_text:'public class className { \n public void execute() {\n \n } \n}',
  output:'',
  input:[],
  steps:[],
  parent_step_id:null,
  steps_index:[],
  assignments:[],
  input_field_id:'',
  output_field_id:'',  
};
class CalculateRates extends Component{
  state = {
    isCreateNewModal:false,
    isArrayElementModalOpen:false,
    arrayElement:null,
    selectedSheetId : '',
    triggerEffect : '',
    assignmentModal : false,
    serviceList : [],
    variablesAndFields : null,
    windowFields : [],
    assignmentVaraibleList : [],
    assignmentList : [],
    dynamicVal : 1,
    // chargeList : [],
    editData : null,
    rateConfig : null,
    rateConfigData:{name:''},
    refRateConfigData:null,
    isSplitViewOpen : true,
    windowsList : [],
    functionMetaList:[],
    windowFields:[],
    currentTab:'variable',
    tabListArr:[{label:'Variable',id:'variable'}],
    //tabListArr:[{label:'Variable',id:'variable'},{label:'Constant',id:'constant'}],
    tableRecords:{
      tableHead:[],
      tableData:[],
      rateSheetConfigVariables:{
        globalVariables:[]        
      }, 
      pagination:{
        page:0,
        orderBy:'variable_name',
        perPage:10,
        direction:true,
        totalRecords:0,
        search:''
      }
    },
    modelGuideOpen:false,
    ratesListCount:0,
    modelGuideDontShow:false ,
    renderAgain:false,
    configApis:[],
    layoutList:[],
    isHiddenCardBoxShow:false,
    searchText:''
  }
  
  goBackHistory = ()=>{
    this.props.history.goBack()
  }
  componentWillUnmount = ()=>{
    this.props.setConfigRatesStepsAction([]);
  }
  componentWillMount = async () => {
    const params = this.props.match.params;
    const {calculationId} = params;
    // console.log(params);
    //await this.props.setConfigRatesStepsAction([defualtCalculateLoad]);
    await this.props.setRateSheetAndConfigVariablesAction({
      global_constants:[],
      global_variables:[],
      rate_sheet_list:[],
      tax_variables:[]
    });
    // console.log('this.props.match.params.calculationId',this.props.match.params);
    this.fetchAllBasicDatas();    
    this.fetchRatesStepsList(this.props.match.params.calculationId);
    this.fetchVariablesListPagination (this.state.tableRecords.pagination);
    this.fetchRateSheetsAndVariablesList(calculationId,false);
    this.fetchRateConfig(calculationId,false);
    // this.toogleGuideHandler();
  }
  
  componentDidUpdate = (prevProps,prevState)=>{    
    // if(JSON.stringify(prevProps.variablesAndSheetList['rateSheetsList'])!==JSON.stringify(this.props.variablesAndSheetList['rateSheetsList'])){   
      //console.log("prevProps.variablesAndSheetList 1",prevProps.variablesAndSheetList['rateSheetsList'],this.props.variablesAndSheetList['rateSheetsList'])   
      // const params = this.props.match.params;
      // this.fetchRatesStepsList(params.formId);
    // }

    
    // if(prevProps.variablesAndSheetList['rateSheetsList'].length === 0 && this.props.variablesAndSheetList['rateSheetsList'].length===0){
      //console.log("prevProps.variablesAndSheetList 2",prevProps.variablesAndSheetList['rateSheetsList'],this.props.variablesAndSheetList['rateSheetsList'])
    // }
  }

  fetchAllBasicDatas = async () => {
    try {
      // Fetch all data concurrently
      const [formulaFieldMetaInfoRes, windowListRes, variableFieldListRes, apiListRes, ratesConfigListRes] = await Promise.all([
        http.GET("layouts/formulafield-metainfo"),
        http.GET("windows/list?query=&page=0&orderBy=display_name&size=10000&direction=ASC"),
        http.GET("rates/field-type-list"),
        http.GET("api-client/list?query=&page=0&orderBy=&size=9999999&direction=ASC"),
        http.GET("rates/configurations/list?query=&page=0&orderBy=&size=10&direction=ASC")
      ]);
  
      // Initialize new state object to avoid multiple re-renders
      const newState = {};
      try{
        // Handle formulaFieldMetaInfo response
        if (formulaFieldMetaInfoRes.data.code === ShipConstants.API_STATUS_SUCCESS) {
          newState.functionMetaList = formulaFieldMetaInfoRes.data.data;
        }
      }catch(e){

      }
      
      try{
        // Handle windowList response
        if (windowListRes.data.code === ShipConstants.API_STATUS_SUCCESS) {
          // console.log('exceptionerror windowListRes',windowListRes);
          newState.windowsList = windowListRes.data.data.windows.content;
        }
      }catch(e){

      }
      
      try{
        // Handle variableFieldList response
        if (variableFieldListRes.data.code === ShipConstants.API_STATUS_SUCCESS) {
          newState.variablesAndFields = variableFieldListRes.data.data;
          // console.log('variableFieldListRes.data',variableFieldListRes.data);
        } else {
          newState.variablesAndFields = [];
        }
      }catch(e){

      }
      
      try{
         // Handle API list response
        if (apiListRes.status === 200 && apiListRes.data.code === 200) {
          const apiList = apiListRes.data.data.content;
          // console.log('apiListRes',apiListRes);
          newState.configApis = apiList.length > 0 ? apiList : [];
        }
      }catch(e){

      }
     
      try{
         // Handle ratesConfigList response
        if (ratesConfigListRes.status === 200 && ratesConfigListRes.data.code === 200) {
          const ratesList = ratesConfigListRes.data.data.content;
          newState.ratesListCount = ratesList.length;
          // You can set configApis from ratesList as needed
          newState.configApis = ratesList.length > 0 ? ratesList[0].rate_configuration_apis || [] : [];
        }
      }catch(e){

      }
      // Set all state updates at once to avoid multiple re-renders
      this.setState(newState);
  
    } catch (error) {
      console.log('exceptionerror',error);
      // Centralized error handling
      // this.props.failMessage("Something went wrong.");
    }
  }

 

 

  rateSheetChangeHandler = (e) => {
    const {name,value} = e.target;
    const data = this.getVaraiblesAndConstantsUsingId(value);
    const updateState = {...this.state}
    updateState[name] = value;
    if(data) {
      updateState['variableList'] = data.global_variables ? data.global_variables : [];
      updateState['constantList'] = data.global_constants ? data.global_constants : [];
    }else {
      updateState['variableList'] = [];
      updateState['constantList'] = [];
    }
    this.setState(updateState);
  }

  

  saveHandler = () => {
    const params = this.props.match.params;
    // console.log(params);
    this.toogleCreateNewHandler();
    this.fetchRateSheetsAndVariablesList(params.formId);
    const pagination = {
        page:0,
        orderBy:'variable_name',
        perPage:10,
        direction:true,
        totalRecords:0,
        search:''
    }
    this.fetchVariablesListPagination (pagination);
    // this.variableAndFieldList(params.formId);
  }

  
  

  toggleAssignmentHandler = (isOpen = false) => {
    // console.log('toggleAssignmentHandler');
    const params = this.props.match.params;
    /*const updateState = {...this.state};
    updateState.assignmentModal = !updateState.assignmentModal;
    if(isOpen)
      updateState.dynamicVal = Math.random();
    this.setState(updateState);*/
    this.props.setRatesConfigData(null,this.state);
    this.props.history.push("/shipping/"+params.windowName+"/"+params.windowId+"/rate-assigment/"+params.layoutId+"/"+params.carrierId+"/"+params.formId);
    // this.props.history.push("/shipping/rate/assigment/"+params.carrierId+'/'+params.action+'/'+params.formId);
  }

  saveAssignmentHandler = () => {
    console.log('saveAssignmentHandler');
  }


  changeTabHandler = (tabId) => {
    //console.log('changeTabHandler',tabId)
    this.setState({
        currentTab:tabId, 
        status:200, 
        tableRecords:{
              rateSheetConfigVariables:{globalVariables:[]},
              tableHead:[],
              pagination:{...this.state.tableRecords.pagination,totalRecords:0}
        }
    });    

    const pagination = {
        page:0,
        orderBy:'variable_name',
        perPage:10,
        direction:true,
        totalRecords:0,
        search:''
    }
    setTimeout(() => {
          this.fetchVariablesListPagination (pagination);                 
    }, 200);
  }

  renderAgainThisPage = () => {
    this.setState({renderAgain:!this.state.renderAgain});
    this.fetchVariablesListPagination (this.state.tableRecords.pagination);
  }

  loadStepsAndVariable = () => {
    this.setState({renderAgain:!this.state.renderAgain});
    this.fetchVariablesListPagination (this.state.tableRecords.pagination);
    // this.fetchRatesStepsList(this.props.match.params.formId); 
    this.fetchRateSheetsAndVariablesList(this.props.match.params.formId);
  }

  cardHiddenBoxHandler = () => {
    this.setState({isHiddenCardBoxShow:!this.state.isHiddenCardBoxShow});
  }

  searchTextHandler = (e) => {
    const{value} = e.target;
    this.setState({searchText:value});
    const pagination = {
        page:0,
        orderBy:'variable_name',
        perPage:10,
        direction:true,
        totalRecords:0,
        search:value
    }
    this.fetchVariablesListPagination (pagination);

  }

  render(){
    const params = this.props.match.params;
    const {functionMetaList,isHiddenCardBoxShow,searchText} = this.state;
    const breadCrumbs =   this.getAndSetBreadCrumbs(params);
      return (
          <Wrp>
            <BreadCrumbs 
                  breadCrumbsList={breadCrumbs} />
            <div className="viewport">
              <div className="view view-xl" id="wrapper">
                
                       
                  <div className="portTwoSection">

                    <LeftContent 
                      toogleCreateNewHandler={this.toogleCreateNewHandler}
                      // rateSheetChangeHandler={this.rateSheetChangeHandler}
                      deleteVaraibleHandler = {this.deleteVaraibleHandler}
                      editToggleModel={this.editToogleCreateNewHandler}
                      changeTabHandler={this.changeTabHandler}
                      tabListArr={this.state.tabListArr}
                      currentTabToShow={this.state.currentTab}
                      tableRecords={this.state.tableRecords}
                      recordsChangeHandler={this.fetchVariablesListPagination }
                      isHiddenCardBoxShow={isHiddenCardBoxShow}
                      cardHiddenBoxHandler={this.cardHiddenBoxHandler}
                      searchTextHandler={this.searchTextHandler}
                      searchText={searchText}
                    />
                    <RightContent 
                      {...this.props}
                      windowFields={this.state.windowFields}
                      layoutList={this.state.layoutList}
                      setWindowFields={this.setWindowFields}
                      functionMetaList={functionMetaList}
                      curState={this.state} 
                      getVaraiblesAndConstantsUsingId={this.getVaraiblesAndConstantsUsingId}
                      closeClonePopup={this.closeClonePopup}
                      renderAgainThisPage={this.renderAgainThisPage}
                      loadStepsAndVariable={this.loadStepsAndVariable}
                    />
                    
                  </div>
                 
              </div>
            </div>
            <CreateNew
              {...this.props}
              curState={this.state}
              modelOpen={this.state.isCreateNewModal}
              toggleModel={this.toogleCreateNewHandler}
              saveHandler={this.saveHandler}
              windowsList={this.state.windowsList}
              triggerEffect={this.state.triggerEffect}
              currentTabToShow={this.state.currentTab}
              toogleArrayElementModel={this.toogleArrayElementModel}
            />
            {/*<ArrayElement
              {...this.props}
              {...this.state}
              toogleArrayElementModel={this.toogleArrayElementModel}
            />*/}
            {
              this.state.modelGuideDontShow === false?
              <GuideModal
                modelGuideOpen={this.state.modelGuideOpen} 
                ratesListCount={this.state.ratesListCount}
                modelGuideDontShow={this.state.modelGuideDontShow}
                toogleGuideHandler={this.toogleGuideHandler}
                guideDontShowHandler={this.guideDontShowHandler}
              />
              :
              null
            }            
          </Wrp>
        
        );
  }

  /********************/
  toogleGuideHandler = ()=>{
    const {modelGuideOpen} = this.state;    
    this.setState({modelGuideOpen:!modelGuideOpen});
  }

  guideDontShowHandler = ()=>{
    const {modelGuideDontShow} = this.state;    
    this.setState({modelGuideDontShow:true,modelGuideOpen:false});
  }
  /********************/


  toogleArrayElementModel = (arrayData) => {
    this.setState({isArrayElementModalOpen:!this.state.isArrayElementModalOpen,arrayElement:arrayData});
  }

  toogleCreateNewHandler = (curTab)=>{
    const {isCreateNewModal} = this.state;
    //this.setState({editData : null, isCreateNewModal:!isCreateNewModal,currentTab:curTab});
    this.setState({editData : null, isCreateNewModal:!isCreateNewModal});
  }

  editToogleCreateNewHandler = (data)=>{
    const {isCreateNewModal} = this.state;
    // http.GET("variable/"+data.id+"/search-fields")
    // .then(response => {
    //   const responseData = response.data;
    //   const updateState = {...this.state}
    //   const resData = data;
    //   if(responseData.code === ShipConstants.API_STATUS_SUCCESS) {
    //     resData['fields'] = responseData.data;
    //     this.setState({triggerEffect : Math.random(),editData : resData, isCreateNewModal:!isCreateNewModal});
    //   }else{
    //     resData['fields'] = [];
    //     this.setState({triggerEffect : Math.random(),editData : resData, isCreateNewModal:!isCreateNewModal});
    //   }
    // }, (error) => {
    //   const resData = data;
    //   resData['fields'] = [];
    //   this.setState({triggerEffect : Math.random(),editData : resData, isCreateNewModal:!isCreateNewModal});
    //   this.props.failMessage("Something went wrong..");
    // })
    this.setState({triggerEffect:Math.random(),editData:data,isCreateNewModal:!isCreateNewModal});
  }

  toogleUploadSheetHandler = ()=>{
    const {isUploadSheet} = this.state;
    this.setState({isUploadSheet:!isUploadSheet})
  }

 

/*  chargeList = () => {
    http.GET("charges/list?orderBy=&direction=ASC&page=0&size=100000")
    .then(response => {    
        const responseData = response.data;
        const updateState = {...this.state}
        if(responseData.code === ShipConstants.API_STATUS_SUCCESS) {
            updateState['chargeList'] = responseData.data;
        }else {
          updateState['chargeList'] = [];
        }
        this.setState(updateState);
    }, (error) => {
    })
  }*/

  // variableAssignment = (configId, windowFields) => {
  //   http.GET("rates/configurations/"+configId+"/variables-assignment")
  //   .then(response => {
  //     const responseData = response.data;
  //     const updateState = {...this.state}
  //     if(responseData.code === ShipConstants.API_STATUS_SUCCESS) {
  //       const windowResponseData = windowFields;
  //       const filedFilters= windowResponseData.fields_with_filters;
  //       responseData.data.forEach(function(entry1) {
  //         let data = findFiltersByFieldIdWithFieldArr(entry1.window_field_id, windowResponseData.fieldGroups, filedFilters);

  //         let lookupField = [];
  //         if(entry1.absolute_window) {
  //           let res = entry1.absolute_window.split(".");

  //           if(res.length > 0) {
  //             res.map((arr1,ind) => {
  //               //sss.push(arr1.id);
  //               const fieldVal = findFiltersByValueAndFilterArray(arr1,windowResponseData.fieldGroups);
  //               lookupField.push(fieldVal);
  //             })
  //           }
            
  //         }
  //         lookupField.push({field_name :data.field_name});
  //         entry1.absolute_window1 = lookupField;
  //       });
  //       updateState['assignmentList'] = responseData.data;

  //     }else {
  //       updateState['assignmentList'] = [];
  //     }
  //     this.setState(updateState);
  //   }, (error) => {
  //     this.props.failMessage("Something went wrong..");
  //   })
  // }

  // my code 07
  fetchVariablesListPagination  = (pagination) => {    
    const params = this.props.match.params;
    let configId = params.calculationId;
    let currentTab = this.state.currentTab;
    let isConstantVal = false;
    if(currentTab === 'constant'){
      isConstantVal = true;
    }
    const page = pagination.page; 
    // const orderBy = pagination.orderBy; 
    const perPage = pagination.perPage; 
    // const direction = pagination.direction; 
    const search = pagination.search;

    this.setState({
        tableRecords:{
          ...this.state.tableRecords,
          pagination:pagination
        }
    });
    
    const queryStringNew = '?search='+search+'&page='+page+'&orderBy=&size='+perPage+'&functionType=RATES&referenceId='+configId;
    http.GET("variable/paginated-search"+queryStringNew)
    .then(response => {
      const responseData = response.data;
      if(responseData.code === ShipConstants.API_STATUS_SUCCESS) {
        if(responseData.data){
          //console.log('variable/paginated-search===',responseData.data); 
          const data = responseData.data;
          const totalRecords = data.total_elements;      
          this.setState({status:200, tableRecords:{
              rateSheetConfigVariables:{globalVariables:data.content,status:200},
            tableHead:[],
              pagination:{...this.state.tableRecords.pagination,totalRecords:totalRecords}
          }});
        }else{
          const totalRecords = 0;//response.data.totalElements;
          this.setState({status:200, tableRecords:{
              rateSheetConfigVariables:{globalVariables:[]},
              tableHead:[],
              pagination:{...this.state.tableRecords.pagination,totalRecords:totalRecords}
          }});
        } 
      }else{
        const totalRecords = 0;//response.data.totalElements;
        this.setState({status:200, tableRecords:{
            rateSheetConfigVariables:{globalVariables:[]},
            tableHead:[],
            pagination:{...this.state.tableRecords.pagination,totalRecords:totalRecords}
        }});
      }
    },(error) => {
      this.props.failMessage("Something went wrong..");
    })

  } 
  // end

  fetchRateSheetsAndVariablesList = (configIdFromParam,isRenderSteps=true) => {

    const params = this.props.match.params;
    let configId = params.calculationId;
    // this.props.Loader(true);
    http.GET("rates/configurations/"+configId+"/rate-sheets")
    .then(response => {
      const responseData = response.data;
      if(responseData.code === ShipConstants.API_STATUS_SUCCESS) {
        const data = responseData.data;
        this.props.setRateSheetAndConfigVariablesAction({
          global_constants:[],
          global_variables:[],
          rate_sheet_list:isSet(data.rate_sheet_list,[]),
          tax_variables:isSet(data.tax_variables,[])
        });
        this.fetchAllVariablesList();
        if(isRenderSteps===true){
          this.fetchRatesStepsList(configId);
        }        
      }else {
        // this.props.Loader(false);
      }
    }, (error) => {
      // this.props.Loader(false);
      this.props.failMessage("Something went wrong..");
      if(isRenderSteps===true){
        this.fetchRatesStepsList(configId);
      } 
    })

  }

  fetchAllVariablesList = () => {
    const params = this.props.match.params;
    let configId = params.calculationId;
    const queryStringNew = '?functionType=RATES&referenceId='+configId;
    http.GET("variable/search"+queryStringNew)
    .then(response => {
      const responseData = response.data;
      if(responseData.code === ShipConstants.API_STATUS_SUCCESS) {
        const data = responseData.data;
        let global_constants = [];
        let global_variables = [];
        isSet(data,[]).map((item,index)=>{
          if(item.is_constant === true){
            global_constants.push(item);
          }else{
            global_variables.push(item);
          }
        })
        this.props.setRateSheetAndConfigVariablesAction({
          ...this.props.variablesAndSheetList,
          global_constants:isSet(global_constants),
          global_variables:isSet(global_variables),
          rate_sheet_list:isSet(this.props.variablesAndSheetList.rateSheetsList,[]),
          tax_variables:isSet(this.props.variablesAndSheetList.taxVariablesList,[])          
        });        
      }else {
        this.props.Loader(false);
      }
    },(error) => {
      this.props.failMessage("Something went wrong..");
    })    
  }


  genereWidowFields = (windowId) => {
    http.GET('field-groups/window/'+windowId+'/lookup-layouts')
    .then(windowResponse => {
        console.log("windowResponse",windowResponse);
        const updateState = {...this.state}
        const responseData = windowResponse.data;
        if(responseData.code === ShipConstants.API_STATUS_SUCCESS) {
          updateState['windowFields'] = responseData.data;
        }else {
          updateState['windowFields'] = [];
        }
        this.setState(updateState);
    }, (error) => {
        console.log(error);
    })
  }

  // setStateValue = (name,value) => {
  //   const params = this.props.match.params;
  //    const updateState = {...this.state}
  //    updateState[name] = value;
  //    // console.log(updateState);
  //    this.setState(updateState);
  //    if(name === 'windowFields') {
  //     // this.variableAssignment(params.action, value);
  //    }
  // }


  deleteVaraibleHandler = (id) => {
    const params = this.props.match.params;
      this.props.Loader();
      http.DELETE("rates/variables/"+id+"/delete")
      .then(response => {
        this.props.Loader();
        const responseData = response.data;
        if(responseData.code === ShipConstants.API_STATUS_SUCCESS) { 
          this.fetchRateSheetsAndVariablesList(params.formId);
          const pagination = {
              page:0,
              orderBy:'variable_name',
              perPage:10,
              direction:true,
              totalRecords:0,
              search:''
          }
          this.fetchVariablesListPagination (pagination);
          this.props.succMessage(responseData.message);
        }else {
          this.props.failMessage(responseData.message);
        }
      })
  }

  getAndSetBreadCrumbs = (params)=>{
    // const params = this.props.match.params;
    const {rateConfigData} = this.state;
    // console.log('ratesConfigSteps',rateConfigData);
    return {
      backHistory : [/*{
        href:"/layouts/"+params.windowName+"/"+params.windowId+"/list/"+params.layoutId,
        name:"Carrier"
        },{
          href:"/shipping/"+params.windowName+"/"+params.windowId+"/rate-config/"+params.layoutId+"/"+params.carrierId,
          name:"Rates Config"
       }*/
        {
        href : "/settings",
          name:"Settings"
        },{
          href:"/calculation/calculation-list",
          name:"Calculation list"
       }],
      pageTitle:isSet(rateConfigData.name,'Calculate Rates'),
      buttonList:[
        {
        name:this.state.refRateConfigData ? "Copy Existing Steps From ( "+this.state.refRateConfigData.name+" )" : '',
        type:"cancel",
        clickHandler:()=>this.openClonePopup(true),
        attributes:{
          className: this.state.refRateConfigData ? "ml-2 btn secondary_bg quick-sidebar-toggler mr-2" :  "btn secondary_bg quick-sidebar-toggler hide"
        }
       },
       // {
       //  name:"Assignment",
       //  type:"save",
       //  clickHandler:this.toggleAssignmentHandler.bind(true),
       //  attributes:{
       //    className:"btn primary_bg",
       //  }
       // }
      ]
    }
  }

  openClonePopup = () => {
    $("html").addClass("quick_sidebar_open");
    $('<div class="quick-sidebar-overlay"></div>').insertAfter(".quick-sidebar");
  }

  closeClonePopup = () => {
    $("html").removeClass("quick_sidebar_open");
    $(".quick-sidebar-toggler").removeClass("toggled");
    $(".quick-sidebar-overlay").remove();
  }
  
  fetchRatesStepsList = (configId) => {
    this.props.Loader(true);
    const windowData = getWindowObjectUsingWindowName("Shipments");
   
    http.GET("rates/configurations/"+configId+"/rate-steps")
    .then( (response) => {
      const responseData = response.data;
      if(responseData.code === ShipConstants.API_STATUS_SUCCESS) {
        let inc = 0;
        let outVarExist = []
       
        responseData.data.map((entry, index)=>{
          // responseData.data.forEach(function(entry) {
          let windId = entry.window_id ? entry.window_id : windowData.window_id;
          if(entry.rate_calculation_steps && entry.rate_calculation_steps.length > 0) {
            windId = entry.rate_calculation_steps[0].window_id ? entry.rate_calculation_steps[0].window_id: windowData.window_id;
          }
          entry.windId = windId;
          entry.isEdit = false;

          let assignmentArr = [];
          let typeVals = 1;
          if(entry.is_sheet === true){
            typeVals = 0;
          }
          if(entry.is_loop === true){
            typeVals = 2;
          }
          if(entry.is_assignment === true){
            typeVals = 3;
            if(entry.assignments){
              assignmentArr = entry.assignments;  
            }            
          }

          if(entry.is_fetch === true){
            typeVals = 4;
          }

          if(entry.is_api === true){
            typeVals = 5;
          }
          if(entry.is_break === true){
            typeVals = 6;
          }
          entry.type = typeVals;
          entry.rules = [];
          entry.assignments = assignmentArr;
          entry.is_show = false;
          //entry.type = entry.is_sheet === true ? 0 : 1;
                if(inc !== 0) {
                  var newArray = [];
                  let uniqueObject = {}; 
                  let newArray1 = [];
                  for (let i in outVarExist) { 
                      let objTitle = outVarExist[i]['id']; 
                      uniqueObject[objTitle] = outVarExist[i]; 
                  }

                  for (let i in uniqueObject) { 
                      newArray1.push(uniqueObject[i]); 
                  }
                  newArray.push.apply(newArray, newArray1);
                  entry.existOutputVariables =newArray;
                }else {
                  entry.existOutputVariables =[];
                }
               
                try{
                  const data = this.getVaraiblesAndConstantsUsingId(entry.rate_sheet_id);
                  const data1= this.getVaraiblesAndConstantsUsingId(responseData.data[inc].rate_sheet_id);
                  const outVar = data1 ? data1.output_variables ? data1.output_variables : [] : [];
                  // console.log("datadatadatadatadata",data,entry);
                let varList = [];
                if(responseData.data[inc].type === 1) {
                  
                      isSet(this.props.variablesAndSheetList['rateSheetsList'],[]).map((arr,ind) => {
                        if(arr.output_variables) {
                          arr.output_variables.map((arr,ind) => {
                            varList.push(arr);
                          })
                        }
                      })
                      isSet(this.props.variablesAndSheetList['taxVariablesList'],[]).map((arr,ind) => {
                        if(arr.variable_type === 'OUTPUT') {
                            varList.push(arr);
                        }
                      })
                  Array.prototype.push.apply(outVarExist, varList);
                }else {
                  Array.prototype.push.apply(outVarExist, outVar);
                }
                inc ++;

                if(data) {
                  entry.input_fields = data.input_variables ? data.input_variables : [];
                  entry.output_fields = data.output_variables ? data.output_variables : [];
                }
                }catch(e){
                  console.log('exception...',e);
                }


                // steps entry start..
                if(entry.steps.length>0){
                  let step_index = [];
                  entry.steps = this.stepsFormJson(entry.steps,index,step_index) 
                }
                // ends
                if(entry.layout_mapping && Array.isArray(entry.layout_mapping) && entry.layout_mapping.length>0) {
                    entry.layout_mapping.map((layMapItem,layInd) => {
                        layMapItem.id=null;
                        if(layMapItem.fields_mapping && Array.isArray(layMapItem.fields_mapping) && layMapItem.fields_mapping.length>0) {
                            let existVariavleIds = [];
                            layMapItem.fields_mapping.map((layItem,layInd) => {
                                existVariavleIds.push(layItem.variableId);
                                layItem.id=null;
                                let lookupField = [];
                                if(layItem.absolute_display && layItem.absolute_display !== '') {
                                    let res = layItem.absolute_display.split(".");
                                    if(res.length > 0) {
                                        res.map((arr1,ind) => {
                                            lookupField.push({field_name :arr1});
                                        })
                                    }
                                }
                                lookupField.push({field_name :layItem.display_name});
                                layItem.absolute_window1 = lookupField;
                                if(layItem.fields_mapping && layItem.fields_mapping.length>0) {
                                  this.setAbsoluteWindow(layItem.fields_mapping);
                                }
                            });
                            if(entry.apiDetails && entry.apiDetails.collection_variables && entry.apiDetails.collection_variables.length>0) {
                                entry.apiDetails.collection_variables.map((varItem,ind) => {
                                    if(existVariavleIds.indexOf(varItem.id) === -1) {
                                        const obj = {
                                            variableName: varItem.variable_name,
                                            variableId: varItem.id,
                                            tableDescriptorId:'',
                                            absolute_window:'',
                                            variableType: varItem.is_request === true || varItem.is_constant ? 'INPUT' : varItem.is_response === true ? 'OUTPUT' : '',
                                            isConstant:varItem.is_constant,
                                            constantValue: varItem.constant_value,
                                            line_no: ind,
                                            fields_mapping:this.prepareFields(varItem.fields)
                                        }
                                        layMapItem.fields_mapping.push(obj);
                                    }
                                    
                                })
                            }
                        }
                        this.setArrayIndexes(layMapItem.fields_mapping);
                    });
                }

                if(typeVals === 5) {
                  entry.layoutMappingFields = {
                    layoutList:entry.layoutList,
                    layout_id:'',
                    layoutMapping:entry.layout_mapping,
                    apiDetails:entry.apiDetails
                  }
                }
                
                return entry;

        })
        //console.log("responseData.data------",responseData.data);        
        if(isSet(responseData.data,[]).length>0){
          this.props.setConfigRatesStepsAction(responseData.data);
          this.props.setConfigRatesStepsActionCopy(JSON.parse(JSON.stringify(responseData.data)));          
          this.props.setExistingConfigRatesStepsAction(JSON.parse(JSON.stringify(responseData.data)));
        }
        // console.log('responseData.data,[])',responseData.data);
        this.generateWindowFields(isSet(responseData.data,[]).length);
        this.props.Loader(false);
      }else{
        this.props.Loader(false);
      }
    }, (error) => {
      this.props.setConfigRatesStepsAction([defualtCalculateLoad]);
      this.props.setConfigRatesStepsActionCopy([defualtCalculateLoad]);
      this.props.Loader(false);
      console.log('exception...',error);
    })
  }

  prepareFields = (fieldArr) => {
    let fields =[];
    if(fieldArr && fieldArr.length>0) {
    fieldArr.map((varItem1,ind1)=>{
          const obj1 = {
                  variableName: varItem1.name,
                  variableId: varItem1.id,
                  tableDescriptorId:'',
                  absolute_window:'',
                  variableType: 'INPUT',
                  isConstant:false,//varItem1.is_variable,
                  constantValue: "",//varItem1.value_expression,
                  line_no: ind1,
                  fields_mapping:this.prepareFields(varItem1.fields)
              }
              fields.push(obj1) 
        })
    }
    return fields;
  }
  setAbsoluteWindow = (fMap) => {
    if(fMap) {
      fMap.map((layItem,layInd) => {
          layItem.id=null;
          let lookupField = [];
          if(layItem.absolute_display && layItem.absolute_display !== '') {
              let res = layItem.absolute_display.split(".");
              if(res.length > 0) {
                  res.map((arr1,ind) => {
                      lookupField.push({field_name :arr1});
                  })
              }
          }
          lookupField.push({field_name :layItem.display_name});
          layItem.absolute_window1 = lookupField;
          if(layItem.fields_mapping && layItem.fields_mapping.length>0) {
            this.setAbsoluteWindow(layItem.fields_mapping);
          }
      });
    }
  }

  setArrayIndexes = (obj) => {
      if(obj) {
        obj.map((objArr,objInd) => {
            if(objArr.fields_mapping && objArr.fields_mapping.length > 0) {
                objArr.fields_mapping.map((fieldArr,fieldInd) => {
                    fieldArr.indexes = ','+fieldInd;
                    fieldArr.displayPosition=fieldInd+1;
                    if(fieldArr.fields_mapping && fieldArr.fields_mapping.length > 0) {
                        this.recursiceSetArrayIndexes(fieldArr,fieldArr.indexes);
                    }
                })
            }
          })
      }
      return obj;
  }

  recursiceSetArrayIndexes = (obj,indexes) => {
    if(obj) {
        if(obj.fields_mapping && obj.fields_mapping.length > 0) {
            obj.fields_mapping.map((fieldArr,fieldInd) => {
                fieldArr.indexes = ','+indexes+','+fieldInd;
                fieldArr.displayPosition=fieldInd+1;
                if(fieldArr.fields_mapping && fieldArr.fields_mapping.length > 0) {
                    this.recursiceSetArrayIndexes(fieldArr,fieldArr.indexes);
                }
            })
        }
    }
  }

  stepsFormJson = (stepsData,ind,stepIndexArr) => {
    const windowData = getWindowObjectUsingWindowName("Shipments");
    let inc = 0;
    let outVarExist = []
    stepsData.map((entry,index)=>{
        // responseData.data.forEach(function(entry) {
    //let windId = windowData.window_id;
    let windId = entry.window_id ? entry.window_id : windowData.window_id;
    if(entry.rate_calculation_steps && entry.rate_calculation_steps.length > 0) {
      windId = entry.rate_calculation_steps[0].window_id ? entry.rate_calculation_steps[0].window_id: windowData.window_id;
    }
    entry.windId = windId;
    entry.isEdit = false;

    let assignmentArr = [];
    let typeVals = 1;
    if(entry.is_sheet === true){
      typeVals = 0;
    }
    if(entry.is_loop === true){
      typeVals = 2;
    }
    if(entry.is_assignment === true){
      typeVals = 3;
      if(entry.assignments){
        assignmentArr = entry.assignments;  
      }            
    }
    if(entry.is_fetch === true){
      typeVals = 4;
    }
    if(entry.is_api === true){
      typeVals = 5;
    }

    entry.type = typeVals;
    entry.rules = [];
    entry.assignments = assignmentArr;
    entry.is_show = false;
    //entry.type = entry.is_sheet === true ? 0 : 1;
    let steps_index_arr = [...stepIndexArr];
    steps_index_arr.push(index);
    entry.steps_index = steps_index_arr;
          if(inc !== 0) {
            var newArray = [];
            let uniqueObject = {}; 
            let newArray1 = [];
            for (let i in outVarExist) { 
                let objTitle = outVarExist[i]['id']; 
                uniqueObject[objTitle] = outVarExist[i]; 
            }

            for (let i in uniqueObject) { 
                newArray1.push(uniqueObject[i]); 
            }
            newArray.push.apply(newArray, newArray1);
            entry.existOutputVariables =newArray;
          }else {
            entry.existOutputVariables =[];
          }
         
          try{
            const data = this.getVaraiblesAndConstantsUsingId(entry.rate_sheet_id);
            const data1= this.getVaraiblesAndConstantsUsingId(stepsData[inc].rate_sheet_id);
            const outVar = data1 ? data1.output_variables ? data1.output_variables : [] : [];
          let varList = [];
          if(stepsData[inc].type === 1) {
            
                isSet(this.props.variablesAndSheetList['rateSheetsList'],[]).map((arr,ind) => {
                  if(arr.output_variables) {
                    arr.output_variables.map((arr,ind) => {
                      varList.push(arr);
                    })
                  }
                })
                isSet(this.props.variablesAndSheetList['taxVariablesList'],[]).map((arr,ind) => {
                  if(arr.variable_type === 'OUTPUT') {
                      varList.push(arr);
                  }
                })
            Array.prototype.push.apply(outVarExist, varList);
          }else {
            Array.prototype.push.apply(outVarExist, outVar);
          }
          inc ++;

          if(data) {
            entry.input_fields = data.input_variables ? data.input_variables : [];
            entry.output_fields = data.output_variables ? data.output_variables : [];
          }
          }catch(e){
            console.log('exception...',e);
          }


          // steps entry start..
          if(entry.steps.length>0){
            //let step_index = [];
           entry.steps = this.stepsFormJson(entry.steps,index,steps_index_arr) 
          }
          // ends
          if(entry.layout_mapping && Array.isArray(entry.layout_mapping) && entry.layout_mapping.length>0) {
            entry.layout_mapping.map((layMapItem,layInd) => {
                layMapItem.id=null;
                if(layMapItem.fields_mapping && Array.isArray(layMapItem.fields_mapping) && layMapItem.fields_mapping.length>0) {
                    let existVariavleIds = [];
                    layMapItem.fields_mapping.map((layItem,layInd) => {
                        existVariavleIds.push(layItem.variableId);
                        layItem.id=null;
                        let lookupField = [];
                        if(layItem.absolute_display && layItem.absolute_display !== '') {
                            let res = layItem.absolute_display.split(".");
                            if(res.length > 0) {
                                res.map((arr1,ind) => {
                                    lookupField.push({field_name :arr1});
                                })
                            }
                        }
                        lookupField.push({field_name :layItem.display_name});
                        layItem.absolute_window1 = lookupField;
                        if(layItem.fields_mapping && layItem.fields_mapping.length>0) {
                          this.setAbsoluteWindow(layItem.fields_mapping);
                        }
                    });
                    if(entry.apiDetails && entry.apiDetails.collection_variables && entry.apiDetails.collection_variables.length>0) {
                        entry.apiDetails.collection_variables.map((varItem,ind) => {
                            if(existVariavleIds.indexOf(varItem.id) === -1) {
                                const obj = {
                                    variableName: varItem.variable_name,
                                    variableId: varItem.id,
                                    tableDescriptorId:'',
                                    absolute_window:'',
                                    variableType: varItem.is_request === true || varItem.is_constant ? 'INPUT' : varItem.is_response === true ? 'OUTPUT' : '',
                                    isConstant:varItem.is_constant,
                                    constantValue: varItem.constant_value,
                                    line_no: ind
                                }
                                layMapItem.fields_mapping.push(obj);
                            }
                            
                        })
                    }
                }
                this.setArrayIndexes(layMapItem.fields_mapping);
            });
          }
          if(typeVals === 5) {
            entry.layoutMappingFields = {
              layoutList:entry.layoutList,
              layout_id:'',
              layoutMapping:entry.layout_mapping,
              apiDetails:entry.apiDetails
            }
          }

          return entry;

  })
    return stepsData;
  }

  getVaraiblesAndConstantsUsingId = (id) => {
    let result = null;
    try{
        isSet(this.props.variablesAndSheetList['rateSheetsList'],[]).map((arr,i) => {
          if(arr.id === id) {
            result = arr;
          }
        })
    } catch(e){

    }
    return result;
  }
  
  setWindowFields = (fields)=>{
    this.setState({
      windowFields:fields
    })
  }
  generateWindowFields = (stepsLength=0) => {
    // this.props.Loader(true);
    const windowData = getWindowObjectUsingWindowName("Shipments");
    http.GET('field-groups/window/'+windowData.window_id+'/lookup-layouts')
      .then(windowResponse => {
        // this.props.Loader(false);
        const responseData = windowResponse.data;
        if(responseData.code === ShipConstants.API_STATUS_SUCCESS) {
          //this.setWindowFields(responseData.data);
          this.windowLayoutList(windowData.window_id,responseData.data);
          this.props.setWindowFieldsDataAction(windowData.window_id,responseData.data);
          // console.log('responseData.data,[]) stepsLength',stepsLength);
          if(stepsLength===0){
            let calculateDataArr = [defualtCalculateLoad];
            calculateDataArr[0]['windowFields'] = responseData.data;
            calculateDataArr[0]['windId'] = windowData.window_id;
            //this.props.setConfigRatesStepsAction(calculateDataArr);
            this.props.setConfigRatesStepsAction([]);
          }
        }else{
          if(stepsLength===0){
            this.props.setConfigRatesStepsAction([defualtCalculateLoad]);
          }
        }
      },(error) => {
        if(stepsLength===0){
          this.props.setConfigRatesStepsAction([defualtCalculateLoad]);
        }
        // this.props.Loader(false);
        console.log(error);
    })
  }

  //Window Layout List 
  windowLayoutList = (windowId,windowFields) => {
    const page = 0;
    const orderBy = '';
    const perPage = 100;
    const direction = '';
    const search = '';

    let layoutList = [{value:'',name:'-None-',label:'-None-'}];
    const queryString = '?query='+search+'&page='+page+'&orderBy='+orderBy+'&size='+perPage+'&direction='+direction;
    http.GET("layouts/window/"+windowId+queryString)
    .then(res => {
      if(res.status===200){ 
        const response = res.data;
        if(response.code===200){
          response.data.content.map((item)=>{
            layoutList.push({
                value:item.id,
                name:item.layout_name,
                label:item.layout_name
            })
          });

          this.setState({
            windowFields:windowFields,
            layoutList:response.data.content
          })
        }
      }
    }, (error) => {
    })
  }

  fetchRateConfig = (configId, isRef=false) => {
    //this.props.Loader(true);
    http.GET("rates/configurations/"+configId)
    .then(response => {
      const responseData = response.data;
      if(responseData.code === ShipConstants.API_STATUS_SUCCESS) {
        const result = responseData.data;
        const updateState = {...this.state}
        if(isRef === true) {
          updateState['refRateConfigData'] = result;
        }else {
          updateState['rateConfigData'] = result; 
          if(result.reference_rateconfig_id) {
            this.fetchRateConfig(result.reference_rateconfig_id,true);  
          } 
        }
        this.setState(updateState);
        if(result.reference_rateconfig_id && result.reference_rateconfig_id !== '') {
          this.referenceConfigStep(result.reference_rateconfig_id);
        }else{
          //this.props.Loader(false);
        }
      }else{
        //this.props.Loader(false);
      }
    }, (error) => {
      //this.props.Loader(false);
      this.props.failMessage("Something went wrong..");
    })
  }

  referenceConfigStep = (configId) => {
    http.GET("rates/configurations/"+configId+"/rate-steps")
    .then(response => {
      const responseData = response.data;
      if(responseData.code === ShipConstants.API_STATUS_SUCCESS) {
        const result = responseData.data;
        this.fetchWindowFieldsDetails(result);
      }else { 
        this.props.Loader(false);
      }
    }, (error) => {
      this.props.Loader(false);
      this.props.failMessage("Something went wrong..");
    })
  }
  fetchWindowFieldsDetails = (result)=>{
    const windowData = getWindowObjectUsingWindowName("Shipments");
    http.GET('field-groups/window/'+windowData.window_id+'/lookup-layouts')
    .then(windowResponse => {
      this.props.Loader(false);
    const windowResponseData = windowResponse.data.data;
    const filedFilters= windowResponseData.fields_with_filters;
    result.forEach(function(entry) {
      entry.rate_calculation_steps.forEach(function(entry1) {
        let data = findFiltersByFieldIdWithFieldArr(entry1.window_field_id, windowResponseData.fields_with_filters.window_fields, filedFilters);
        let data1 = findFiltersOjectByFilterIdAndFilterArray(entry1.condition_id, data.filters);
        // console.log(data,data1);
        entry1.field_name = data.field_name;
        entry1.filterName = data1.name;
      })
    })
    const updateState = {...this.state}
    updateState['rateConfig'] = result;
    this.setState(updateState);
  }, (error) => {
    this.props.Loader(false);
    this.props.failMessage("Something went wrong..");
  })
  }

 

  

  findFiltersOjectByFilterIdAndFilterArray = (filterId, filterArray) => {
    let data = [];
    if(filterArray) {
      filterArray.map((arr,i) => {
        if(arr.filterId === filterId) {
          data = arr;
        }
      })
    }
    return data;
  }
}

const mapStateToProps = state => {
  return {
    authenticated: state,
    existState : state.RateConfigReducer.existState,
    ratesConfigSteps:state.RateConfigReducer.ratesConfigSteps,
    ratesConfigStepsCopy:state.RateConfigReducer.ratesConfigStepsCopy,    
    existRateStep:state.RateConfigReducer.ratesExistingConfigSteps,
    variablesAndSheetList:state.RateConfigReducer.rateSheetConfigVariables
  };
}

const mapDispatchToProps = dispatch => {
    return {
      Loader : (bool) => dispatch(actions.loader(bool)),
      succMessage : (msg) => dispatch(actions.succMessage(msg)),
      failMessage : (msg) => dispatch(actions.failMessage(msg)),
      setRatesConfigData : (req,payload) => dispatch(actions.setRatesConfigData(req,payload)),
      setConfigRatesStepsAction:(payload)=>dispatch(setConfigRatesStepsAction(payload)),
      setConfigRatesStepsActionCopy:(payload)=>dispatch(setConfigRatesStepsActionCopy(payload)),      
      setExistingConfigRatesStepsAction:(payload)=>dispatch(setExistingConfigRatesStepsAction(payload)),
      setRateSheetAndConfigVariablesAction:(obj)=>dispatch(setRateSheetAndConfigVariablesAction(obj)),
      setWindowFieldsDataAction:(winId,obj)=>dispatch(setWindowFieldsDataAction(winId,obj))
    };
}
export default
    connect(
      mapStateToProps, 
      mapDispatchToProps
    )(withRouter(CalculateRates));
